import type { TSetTranslationKeys } from '@crehana/ts-types';

import type es from './localeEs';
import { routesEn } from './routes';

export type TKeys = TSetTranslationKeys<typeof es>;

type TTranslations = { en: Record<TKeys, string> };

const localeEn: TTranslations = {
  en: {
    ...routesEn.en,
    ADD_COURSE_DIALOG_SEARCH: 'Search course',
    ADD_COURSE_DIALOG_QUIT: 'Quit',
    ADD_COURSE_DIALOG_ADD: 'Add',
    ADD_COURSE_DIALOG_SAVE: 'Save changes',

    STAT_CARD_DESCRIPTION: 'vs previous week',

    SNACKBAR_DEFAULT_ERROR: 'Oops! an error occurred, please try again later',
    SNACKBAR_DEFAULT_SUCCESS:
      'The report is being generated, you will receive an email with the result in a few minutes.',
    SNACKBAR_REPORT_EXISTS_ERROR:
      'A report of this type is already in the process of generation. Please wait for it to finish before requesting a new one.',

    SEARCH_BY_USERS_HINT: 'Search by users',

    HEADER_BACK_BUTTON_VIEW: 'Back',

    TOUR_BUTTON_AGAIN: 'Tour again',
    TOUR_BUTTON_START: 'Start',
    TOUR_BUTTON_NEXT: 'Next',
    TOUR_TITLE_LAST: 'Great job!',
    TOUR_DESCRIPTION_LAST:
      'You are ready to begin. If you want to revisit this Onboarding later, you can go to the Administrator Guide. We have many more resources for you that can help you make the most of the platform.',

    ERROR_CASE_TITLE: 'Oops, an error occurred',
    ERROR_CASE_BODY: 'Try again later, or press the button below to retry',
    ERROR_CASE_BUTTON: 'Refresh',

    ROUTE_MARKET_CONFIG: 'Configuration',

    STUDENT_COUNTER_BEGINNER: 'Beginner',
    STUDENT_COUNTER_MIDDLE: 'Intermediate',
    STUDENT_COUNTER_ADVANCED: 'Advanced',
    STUDENT_COUNTER_PERSONS: '{{count}} person',
    STUDENT_COUNTER_PERSONS_plural: '{{count}} people',

    FAQ_DIALOG_TITLE: 'Frequently Asked Questions',
    FAQ_DIALOG_BODY: 'If you have an additional query, write to',

    ERROR_MESSAGE_TITLE: 'Oops, something went wrong',
    ERROR_MESSAGE_SUBTITLE: 'please try again later.',
    ERROR_MESSAGE_BUTTON: 'Try again',

    INBOX_PANEL_BUTTON: 'View all messages',
    INBOX_PANEL_NO_MESSAGES: 'You have no messages yet',
    INBOX_PANEL_GO_CHAT: 'Go to chat',
    INBOX_PANEL_CHAT: 'Mentor Chat',

    INBOX_ITEM_SEND_IMAGE_1: 'You sent an image',
    INBOX_ITEM_SEND_IMAGE_2: 'Sent an image',
    INBOX_ITEM_SEND_FILE_1: 'You sent a file',
    INBOX_ITEM_SEND_FILE_2: 'Sent a file',
    INBOX_ITEM_SEND_CHAT_1: 'You started a conversation',
    INBOX_ITEM_SEND_CHAT_2: 'Started a conversation',
    INBOX_ITEM_SPECIALIZATION: 'Specialization',

    NEWS_TITLE: 'Latest at Crehana',
    NEWS_TAB_UPDATES: 'Updates',
    NEWS_TAB_COURSES: 'Courses',

    DEFAULT_BUTTON_AGAIN: 'Retry',
    DEFAULT_LABEL_NEWS: 'You will soon discover all the news we have for you!',

    NEWS_NOTIFICATIONS_LABEL: 'Notifications',

    DASHBOARD_LIST: 'My profiles',
    DASHBOARD_LX: 'Student Panel',
    DASHBOARD_LX_SM: 'Student',
    DASHBOARD_LEADER: 'Leader',
    DASHBOARD_ADMIN: 'Administrator',

    PROFILE_ACCOUNT: 'Account',
    PROFILE_PROFESSOR: 'Professor Panel',
    PROFILE_MENTOR: 'Mentor',
    PROFILE_ADMIN: 'Administrator',
    PROFILE_LEADER: 'Leader',
    PROFILE_MEMBER: 'Collaborator',
    PROFILE_COURSES: 'My courses',
    PROFILE_PROFILE: 'My Profile',
    PROFILE_MANAGE_ACCOUNT: 'Manage Account',
    PROFILE_HELP_CENTER: 'Help Center',
    PROFILE_PANEL: 'Panel',
    PROFILE_NIGHTSWITCH: 'Night Mode',
    PROFILE_CONFIGURATION: 'Configuration',
    PROFILE_MENTORS: 'Mentors',
    PROFILE_LOGOUT: 'Logout',

    SEARCH_HEADER_HINT_1: 'Search users',
    SEARCH_HEADER_HINT_2: 'or organizations',
    SEARCH_HEADER_HINT_3: 'or routes',
    SEARCH_HEADER_USERS: 'Users',
    SEARCH_HEADER_TRACKS: 'Routes',
    SEARCH_HEADER_ORGANIZATIONS: 'Organizations',
    SEARCH_EMPTY_TITLE: 'No results found',
    SEARCH_EMPTY_SUBTITLE: 'Try more general keywords',
    SEARCH_ALL_RESULTS: 'View all results',

    DEFAULT_SEARCH_HINT: 'Search',

    MENU_ROUTE_MY_SHOP: 'Shop',
    MENU_ROUTE_CONTENT: 'Add Content',
    MENU_ROUTE_METRICS_1: 'Statistics',
    MENU_ROUTE_METRICS_NEW: 'Analytics',
    MENU_ROUTE_ADMIN: 'Manage',
    MENU_ROUTE_PROJECTS: 'Projects',
    MENU_ROUTE_CERTIFICATES_GALLERY: 'Certificates',
    MENU_ROUTE_KNOWLEDGE_HUB_DOCUMENTS: 'Documents',
    MENU_ROUTE_KNOWLEDGE_HUB_CATALOG: 'Catalog',
    MENU_ROUTE_SKILL_IQ: 'Skill XP',
    MENU_ROUTE_SKILL_XP_EVOLUTION: 'Skill XP Evolution',
    MENU_ROUTE_INTEGRATIONS: 'Integrations',
    MENU_ROUTE_CLASSROOM: 'Classrooms',
    MENU_ROUTE_STUDIO: 'Studios',
    MENU_ROUTE_ELEVATE: 'Elevate',
    MENU_ROUTE_ELEVATE_CONTENT: 'Content',
    MENU_ROUTE_GAMIFICATION: 'Gamification',
    MENU_ROUTE_CONFIG: 'Configuration',
    MENU_ROUTE_GUIDE: 'Help',
    MENU_ROUTE_METRICS_2: 'Statistics',
    MENU_ROUTE_ADMIN_2: 'Manage',
    MENU_ROUTE_TALENT: 'Talent',
    MENU_ROUTE_CONFIG_2: 'Configuration',
    MENU_ROUTE_INDUCTION: 'Induction',
    MENU_ROUTE_FEEDBACK: 'Feedback',
    MENU_ROUTE_REPORTS: 'Reports',
    MENU_ROUTE_HELP: 'Support',
    MENU_ROUTE_NEW_HELP: 'Help',
    MENU_ROUTE_HANA_AI: 'Crehana AI',
    REPORTS_NESTED_ROUTE_1: 'Published',
    REPORTS_NESTED_ROUTE_2: 'Customized',
    REPORTS_NESTED_ROUTE_3: 'Scheduled',
    REPORTS_NESTED_ROUTE_4: 'Schedule',

    MENU_LEADER_METRICS: 'Statistics',
    MENU_LEADER_PROJECTS: 'Projects',
    MENU_LEADER_GUIDE: 'Leader Guide',

    LEADER_METRICS_NESTED_1: 'General',
    LEADER_METRICS_NESTED_2: 'By users',

    MENU_ROUTE_CONTENT_1: 'Learning Paths',
    MENU_ROUTE_CONTENT_3: 'Ecommerce Routes',
    MENU_ROUTE_CONTENT_2: 'Own Courses',
    MENU_ROUTE_CONTENT_4: 'Live Sessions',

    STATISTICS_LEARNING: 'Learning',
    GENERAL_NESTED_ROUTE_1: 'General',
    GENERAL_NESTED_ROUTE_2: 'By users',
    GENERAL_NESTED_ROUTE_3: 'By routes',
    GENERAL_NESTED_ROUTE_4: 'By courses',

    ROUTE_MANAGE_NESTED_1: 'Attributes',
    ROUTE_MANAGE_NESTED_2: 'Users',
    ROUTE_MANAGE_NESTED_3: 'By routes',
    ROUTE_MANAGE_NESTED_4: 'Teams',
    ROUTE_MANAGE_NESTED_5: 'Automations',
    ROUTE_MANAGE_NESTED_6: 'Custom attributes',
    ROUTE_MANAGE_NESTED_5_1: 'New automation',
    ROUTE_MANAGE_NESTED_5_2: 'Edit automation',
    ROUTE_MANAGE_NESTED_5_3: 'User details',

    ROUTE_CORP_MANAGE_1: 'By organizations',
    ROUTE_CORP_MANAGE_2: 'By administrators',

    ROUTE_TALENT_NESTED_1: 'Talent management',
    ROUTE_TALENT_NESTED_2: 'Engagement',
    ROUTE_TALENT_NESTED_3: 'Performance',

    CONFIGURATION_NESTED_1: 'Account',
    CONFIGURATION_NESTED_2: 'Appearance',
    CONFIGURATION_NESTED_3: 'Communications',
    CONFIGURATION_NESTED_4: 'Certifications',

    INTEGRATIONS_NESTED_ROUTE_1: 'Discover',
    INTEGRATIONS_NESTED_ROUTE_2: 'My integrations',
    INTEGRATIONS_NESTED_ROUTE_3: 'Customization',
    INTEGRATIONS_NESTED_ROUTE_4: 'Credentials',

    SKILL_IQ_GENERAL_NESTED_1: 'General',
    SKILL_IQ_GENERAL_NESTED_2: 'By users',
    SKILL_IQ_GENERAL_NESTED_3: 'By Routes',

    SKILL_XP_EVOLUTION_NESTED_1: 'Launched',
    SKILL_XP_EVOLUTION_NESTED_2: 'Results',

    REPORTS_NESTED_1: 'Reports',
    REPORTS_NESTED_2: 'Custom Report',

    GAMIFICATION_NESTED_1: 'Progress',
    GAMIFICATION_NESTED_2: 'Rewards',

    NEW_ROUTE: 'New',

    SIDEBAR_TITLE_DARK_MODE: 'Dark Mode',
    SIDEBAR_MENU_TITLE: 'My Panel',

    DEFAULT_SEE_DETAIL: 'See detail',

    NEWS_DIALOG_TYPE: 'NEW IN PANEL',
    NEWS_DIALOG_COURSE_TYPE: 'NEW COURSE',
    NEWS_DIALOG_BTN_DETAIL: 'See detail',

    HEADER_PREVIEW_DURATION: 'Duration: ',
    HEADER_PREVIEW_LEVEL: 'Level: ',
    HEADER_PREVIEW_CERTIFICATION_AVAILABLE: 'Certification',
    HEADER_PREVIEW_CERTIFICATION_UNAVAILABLE: 'No certification',
    HEADER_PREVIEW_ACTIVE: 'Active',
    HEADER_PREVIEW_INACTIVE: 'Inactive',
    PREVIEW_VIDEO_TRAILER: 'Watch trailer',
    PREVIEW_VIDEO_OWN_COURSE: 'Own Course',

    COURSE_DETAIL_NESTED_ROUTE_GENERAL: 'General',
    COURSE_DETAIL_NESTED_ROUTE_PROJECTS: 'Projects',
    COURSE_DETAIL_NESTED_ROUTE_REVIEWS: 'Reviews',
    COURSE_DETAIL_NESTED_ROUTE_EVALUATIONS: 'Evaluations',
    COURSE_DETAIL_NESTED_ROUTE_REPORT_SURVEY: 'Survey',
    COURSE_DETAIL_NESTED_ROUTE_LIVE_SESSIONS: 'Live sessions',

    USER_COURSE_DRAWER_TITLE: 'Assign Course',
    USER_COURSE_DRAWER_TITLE_2:
      'In the student panel, the course will be displayed in "Courses assigned for you" and not associated with a learning path.',
    USER_COURSE_DRAWER_CANCEL: 'Cancel',
    USER_COURSE_DRAWER_ASSIGN: 'Assign',
    USER_COURSE_DRAWER_HINT_1: 'Users',
    USER_COURSE_DRAWER_HINT_2:
      'Search for the users you will assign to this course.',
    USER_COURSE_DRAWER_PLACEHOLDER: 'Enter the name or email of the user',
    USER_COURSE_DRAWER_NOT_FOUND: 'No users found',
    USER_COURSE_DRAWER_DONE_TITLE_1: 'This course was assigned to',
    USER_COURSE_DRAWER_DONE_TITLE_2: 'user(s)',
    USER_COURSE_DRAWER_DONE_SUBTITLE:
      'They will access the course from the student panel',
    USER_COURSE_DRAWER_DONE_BUTTON: 'Understood',

    TABS_SOON_AVAILABLE_TITLE: 'Available soon',

    TABLE_EMPTY_STATE_1: 'Sorry, no results found',
    TABLE_EMPTY_STATE_2: 'Try again with a different term.',

    TABLE_CONTAINER_SELECTED: 'Selected',
    TABLE_CONTAINER_DELETE: 'Delete',

    GLOBAL_CANCEL: 'Cancel',
    GLOBAL_CONTINUE: 'Continue',
    GLOBAL_ACCEPT_CONTINUE: 'Yes, continue',
    GLOBAL_UNDERSTAND: 'Understood',
    GLOBAL_REQUIRED_FIELDS: '* Required fields',

    LAST_UPDATE_GENERAL: 'Last information update: {{date}} at 00:00 hours',
    LAST_UPDATE_GENERAL_DESC:
      'The charts only show study hours of active users.',

    REPORT_1_TITLE: 'General Report',
    REPORT_1_DESCRIPTION:
      'Organization progress, course details, user performance, and account activity',
    REPORT_2_TITLE: 'Organization Users',
    REPORT_2_DESCRIPTION:
      'Users added to the platform (active and pending), includes attributes and tags',
    REPORT_3_TITLE: 'Pending Users',
    REPORT_3_DESCRIPTION:
      'Users who have not yet activated their Crehana for business accounts',
    REPORT_4_TITLE: 'Users with No Started Courses',
    REPORT_4_DESCRIPTION:
      'Users who activated their accounts but have not started any courses',
    REPORT_5_TITLE: 'General Learning Paths',
    REPORT_5_DESCRIPTION:
      'Progress of all published routes, includes assigned user details',
    REPORT_6_TITLE: 'Course Report',
    REPORT_6_DESCRIPTION: 'Progress of your users in the course "{{title}}"',
    REPORT_7_TITLE: 'Route Report',
    REPORT_7_DESCRIPTION: 'Progress of your users in the route "{{title}}"',
    REPORT_8_TITLE: 'Teams',
    REPORT_8_DESCRIPTION:
      'Activity status of leaders with information about team members and links to team statistics.',
    REPORT_9_TITLE: 'Eval. as class result',
    REPORT_9_DESCRIPTION:
      'General summary of evaluation results as a class across all courses.',
    REPORT_10_TITLE: 'Eval. as class detail',
    REPORT_10_DESCRIPTION:
      'Detail showing all questions and answers recorded by users.',
    REPORT_11_TITLE: 'Evaluations and general report',
    REPORT_11_DESCRIPTION:
      'Evaluation results combined with a general report with active user filters',
    SEND_REPORT: 'Send report',
    TITLE_BUTTON_REDIRECT: 'View reports',

    ROUTEITEM_DETAIL_ROUTES_COURSES: 'courses',
    ROUTEITEM_DETAIL_ROUTES_REQ: 'Requirements:',
    ROUTEITEM_DETAIL_ROUTES_QUIZES: '{{count}} evaluations',
    ROUTEITEM_DETAIL_ROUTES_PROJECT: '1 project',
    ROUTEITEM_DETAIL_ROUTES_COURSES_TITLE: 'ROUTE COURSES',

    CARDCOURSE_DETAIL_COURSE_REQUIRED: 'Required',
    CARDCOURSE_DETAIL_COURSE_PROFESSOR: 'By {{name}}',
    CARDCOURSE_DETAIL_COURSE_MODULES: '{{count}} modules',

    MULTISELECT_TABLE_CONTAINER_SELECTED: 'selected from this page',
    MULTISELECT_TABLE_CONTAINER_SELECTED_PARTIAL: 'items selected',
    MULTISELECT_TABLE_CONTAINER_SELECTED_ALL:
      'All {{items}} items have been selected',
    MULTISELECT_TABLE_CONTAINER_SELECT_ALL: 'Select all {{totalItems}} items',
    MULTISELECT_TABLE_CONTAINER_DELETE: 'Clear selection',

    INDUCTION_NESTED_1: 'Summary',
    INDUCTION_NESTED_2: 'Workflow',
    INDUCTION_NESTED_3: 'Documents',
    INDUCTION_NESTED_4: 'Tracking',
    INDUCTION_NESTED_5: 'Stages',

    ROUTES_REPORT_TITLE: 'Ready! We are preparing your report',
    ROUTES_REPORT_TITLE_BODY:
      'In a few minutes, we will be sending you the excel report to your email with the requested information. It will also be available in the Reports section as part of the history of reports generated in the platform.',
    ROUTES_REPORT_TITLE_BUTTON: 'Understood',

    REPORTS_TAB_DIALOG_BUTTON: 'View reports',

    UPLOAD_DEFAULT_ERROR: 'Oops an error occurred, please try again later',

    HEADER_HELP: 'Help',

    STEP_2_SUBTITLE: 'We will verify that everything is correct with your file',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT: 'Invalid Format',
    MASSIVE_STEP_1_INPUT_INVALID_FORMAT_DESC:
      'Make sure the file is in a valid format, such as .xlsx.',
    NOTIFICATION_TITLE: 'Messaging center for mailings',
    NOTIFICATION_SUBTITLE:
      'Send mailings to your team and customize the details to ensure, that everyone receives the right information',
    NOTIFICATION_CTA_SEND: 'Send test mailing',
    NOTIFICATION_SEND: 'Send',
    NOTIFICATION_LOADING: 'Loading Image',
    NOTIFICATION_REEMPLACE: 'Replace image',
    NOTIFICATION_ERROR_LABEL: 'An error occurred during upload',
    NOTIFICATION_RETRY: 'Retry',
    NOTIFICATION_SUBMIT_PLACEHOLDER: 'Enter email subject',
    NOTIFICATION_SUBMIT_LABEL: 'Subject of the mail ***(*Obligatory)***',
    NOTIFICATION_SUBMIT:
      'Make sure you complete your route before the time expires!',
    NOTIFICATION_TEXTAREA_PLACEHOLDER: 'Enter a title',
    NOTIFICATION_ERROR_SIZE: 'Your file exceeds the maximum size',
    NOTIFICATION_PROGRESS_LABEL: 'Uploading image',
    NOTIFICATION_ATTACHMENT: 'Upload attachment',
    NOTIFICATION_ERROR_INPUT: 'You must complete this field',
    NOTIFICATION_ATTACHMENT_WARNING: '(Max. 3 files, max. size: 20MB)',
    NOTIFICATION_TOAST_SUCCESS_TITLE: 'The test mail was sent successfully',
    NOTIFICATION_TOAST_SUCCESS_SUBTITLE:
      'Check your mailbox, or unwanted messages',
    NOTIFICATION_TOAST_ERROR_TITLE:
      'An error occurred while sending the test mail',
    NOTIFICATION_TOAST_ERROR_SUBTITLE: 'Please try again later...',
    NOTIFICATION_TOAST_LOADING_TITLE: 'We are sending the test mail',
    NOTIFICATION_TOAST_LOADING_SUBTITLE: 'This action may take a few minutes',
    NOTIFICATION_DROP_TEXT: 'Drag your image to upload or *choose your file*',
    NOTIFICATION_WARNING: 'Size: 600 x 192 px, Max: 2 MB, Format: PNG, JPG',
    NOTIFICATION_CTA_PATH: 'Go to path',

    NOTIFICATION_CUSTOM_TITLE: 'Complete the path {{customTitle}}',
    NOTIFICATION_ATTACHMENT_RETRY: 'Try again',
    FILE_SIZE_ERROR: 'File weight exceeds the allowed limit',
    NOTIFICATION_TOAST_SUCCESS_EMAIL_TITLE:
      'The email was successfully sent to the selected users',
    NOTIFICATION_TOAST_ERROR_EMAIL_TITLE:
      'An error occurred while sending mail to the selected users.',
    NOTIFICATION_TOAST_ERROR_EMAIL_SUBTITLE: 'Please try again later',
    NOTIFICATION_CUSTOM_TOOLTIP:
      'This test email will be sent to the email with which you are logged in as administrator',
    NOTIFICATION_ATTACHMENT_HELPER:
      'Allowed formats: JPG, JPEG, PNG, GIF, BMP, PDF, DOC, DOCX, XLS, XLSX, PPT, PPTX and ZIP',
    NOTIFICATION_SUBMIT_COURSE:
      "You have an uncompleted course; don't forget to finish it.",
    NOTIFICATION_SUBMIT_SESSION:
      "Your live session is just a few minutes away - don't miss it!",
    NOTIFICATION_CTA_COURSE: 'Go to course',
    NOTIFICATION_CTA_SESSION: 'See next sessions',
    NOTIFICATION_CUSTOM_TITLE_COURSE: 'Complete course: {{customTitle}}',
    NOTIFICATION_CUSTOM_TITLE_SESSION: 'Login to session: {{customTitle}}',

    // dropdown filter by tabs
    BACK: 'Back',
    DASHBOARD_FILTER_SELECTOR_BUTTON: 'Filter by',
    DASHBOARD_FILTER_VIEW_ALL: 'View all',
    DASHBOARD_FILTER_SELECTOR_TITLE_1: 'By attributes',
    DASHBOARD_FILTER_SELECTOR_TITLE_ATTR: 'Attributes',
    DASHBOARD_FILTER_SELECTOR_DESC_1:
      'Use criteria to filter users based on the attributes with which they have been tagged.',
    DASHBOARD_FILTER_SELECTOR_TITLE_2: 'Segmentation rules',
    DASHBOARD_FILTER_SELECTOR_DESC_2:
      'Group users based on different predefined data segments.',
    DASHBOARD_FILTER_SELECTOR_TITLE_3: 'Saved filters',
    DASHBOARD_FILTER_SELECTOR_DESC_3:
      'Access saved views here to quickly segment information.',
    DASHBOARD_FILTER_SELECTOR_TITLE_4: 'Users',
    DASHBOARD_FILTER_SELECTOR_DESC_4:
      'Group users based on different predefined data segments.',
    DASHBOARD_FILTER_SELECTOR_TOOLTIP: 'WIP',
    DASHBOARD_USERS_FILTER_ASC: 'Ascending',
    DASHBOARD_USERS_FILTER_DES: 'Descending',
    DASHBOARD_USERS_FILTER_ORDER: 'Order by',
    DASHBOARD_USERS_FILTER_ALPHABETICAL: 'Alphabetical',
    DASHBOARD_USERS_FILTER_NUMERIC: 'Numeric',
    DASHBOARD_USERS_FILTER_DATE: 'Date',
    DASHBOARD_FILTERS_ATTRIBUTES_APPLY: 'Apply',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD: 'Add',
    DASHBOARD_FILTERS_ATTRIBUTES_ADD_SEGMENT: 'Add a segment',
    DASHBOARD_FILTERS_ATTRIBUTES_RANGE: 'to',
    DASHBOARD_FILTERS_NOT_DATA_TITLE: 'You have no attributes created yet',
    DASHBOARD_FILTERS_NOT_DATA_SUBTITLE:
      'Add new attributes to your users to unlock advanced filtering features.',
    DASHBOARD_FILTERS_NOT_DATA_LINK: 'Create attributes',
    SAVE_FILTERS: 'Save filters',
    APPLY_FILTERS: 'Apply filters',
    DASHBOARD_FILTERS_ATTRIBUTES_REMOVE: 'Remove filter',
    DASHBOARD_FILTERS_ATTRIBUTES_EDIT: 'Edit filter',
    SAVE_FILTERS_NAME_INPUT: 'Enter a name for your filter',
    SAVE_FILTERS_NAME_PLACEHOLDER: 'Space to write text',
    SAVE_FILTERS_BUTTON_SAVE: 'Save',
    SAVE_FILTERS_BUTTON_CANCEL: 'Cancel',
    SAVE_FILTERS_ERROR_REQUIRED: 'The name field is required',
    SAVE_FILTERS_ERROR_MESSAGE: 'An error occurred while saving the filter',
    SAVED_FILTERS_OPTIONS_SELECTED: 'Selected options',
    SAVED_FILTERS_ERROR_TITLE: 'There was an error loading the information',
    SAVED_FILTERS_ERROR_SUBTITLE: 'Click the button to try loading again.',
    SAVED_FILTERS_ERROR_RETRY_BUTTON: 'Retry',
    UPDATE_FILTERS_ERROR_MESSAGE: 'An error occurred while updating the filter',
    SEARCH_FILTER_SAVE: 'Search saved filters',
    SEARCH_FILTER_LABEL: 'Select a saved filter option to filter information:',

    NUMERIC_LABEL_PLACEHOLDER: 'Add a segment',
    NUMERIC_RADIO_1: 'Is equal to',
    NUMERIC_RADIO_2: 'Does not contain',
    NUMERIC_RADIO_3: 'Range from',
    NUMERIC_RADIO_4: 'Ends with',
    NUMERIC_RADIO_5: 'Starts with',
    NUMERIC_RADIO_6: 'Any value',
    NUMERIC_RADIO_7: 'Contains',

    ATTRIBUTES_TAGS: 'tags',
    ATTRIBUTES_DELETE: 'Delete all',
    ATTRIBUTES_NOT_FOUND_TITLE: 'No results found for',
    ATTRIBUTES_NOT_FOUND_SUBTITLE: 'Try again with a different term.',
    ATTRIBUTES_PLACEHOLDER_SEARCH: 'Search user attribute',

    STEP_1_SEGMENTATION_RULES_LIST_DESC_1: 'Filter users that match ',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_2: 'all',
    STEP_1_SEGMENTATION_RULES_LIST_DESC_3: ' of the following conditions:',
    STEP_1_SEGMENTATION_RULES_DELETE_ALL: 'Delete all',
    STEP_1_SEGMENTATION_RULES_ITEMS_MAX:
      'You have reached the limit of 5 rules maximum.',
    STEP_1_SEGMENTATION_RULES_ITEMS_ADD: 'Add rule',
    LIST_ATTRIBUTES_ITEM_1: 'Alphabetical',
    LIST_ATTRIBUTES_ITEM_2: 'Numeric',
    LIST_ATTRIBUTES_ITEM_3: 'Date',
    SEGMENTATION_LABEL_DROPDOWN_1: 'Conditional',
    SEGMENTATION_LABEL_DROPDOWN_2: 'Tags',
    ERROR_CHECK_DC3_TEMPLATES:
      'There was an error checking if the organization has DC3 certificates',
    TRACKS_EXPORT_BUTTON_LABEL: 'Download Report',
  },
};

export default localeEn;
